var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "100",
        height: "30",
        viewBox: "0 0 150 50",
        xmlns: "http://www.w3.org/2000/svg",
        "attr-fill": "green"
      }
    },
    [
      _c("circle", { attrs: { cx: "15", cy: "15", r: "15" } }, [
        _c("animate", {
          attrs: {
            attributeName: "r",
            from: "15",
            to: "15",
            begin: "0s",
            dur: "0.8s",
            values: "15;9;15",
            calcMode: "linear",
            repeatCount: "indefinite"
          }
        }),
        _vm._v(" "),
        _c("animate", {
          attrs: {
            attributeName: "fill-opacity",
            from: "1",
            to: "1",
            begin: "0s",
            dur: "0.8s",
            values: "1;.5;1",
            calcMode: "linear",
            repeatCount: "indefinite"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "circle",
        { attrs: { cx: "60", cy: "15", r: "9", "fill-opacity": "0.3" } },
        [
          _c("animate", {
            attrs: {
              attributeName: "r",
              from: "9",
              to: "9",
              begin: "0s",
              dur: "0.8s",
              values: "9;15;9",
              calcMode: "linear",
              repeatCount: "indefinite"
            }
          }),
          _vm._v(" "),
          _c("animate", {
            attrs: {
              attributeName: "fill-opacity",
              from: "0.5",
              to: "0.5",
              begin: "0s",
              dur: "0.8s",
              values: ".5;1;.5",
              calcMode: "linear",
              repeatCount: "indefinite"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "105", cy: "15", r: "15" } }, [
        _c("animate", {
          attrs: {
            attributeName: "r",
            from: "15",
            to: "15",
            begin: "0s",
            dur: "0.8s",
            values: "15;9;15",
            calcMode: "linear",
            repeatCount: "indefinite"
          }
        }),
        _vm._v(" "),
        _c("animate", {
          attrs: {
            attributeName: "fill-opacity",
            from: "1",
            to: "1",
            begin: "0s",
            dur: "0.8s",
            values: "1;.5;1",
            calcMode: "linear",
            repeatCount: "indefinite"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-daba12fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-daba12fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Loading.vue
// module id = null
// module chunks = 